import { gql } from '@apollo/client';

/**
 * Description - graphql query to update a section
 */
export const UPDATE_SECTION = gql`
  mutation update_qat_checklist_theme_section_by_pk(
    $id: Int!
    $object: qat_checklist_theme_section_set_input!
  ) {
    update_qat_checklist_theme_section_by_pk(
      pk_columns: { id: $id }
      _set: $object
    ) {
      specification
    }
  }
`;
